import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setGasElectric } from 'state/fuel-type/fuel-type-slice';
import { setBillingConsent } from 'state/fmrs/fmrs-slice';

export const useMoveInSetup = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setGasElectric());
    dispatch(setBillingConsent(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
